import { FC, useEffect, useState } from "react";
import TextButton from "../shared_components/text-button";
import useAxios from "axios-hooks";
import EntitySet from "../results/EntitySet";
import { IEntity } from "../results/Entity";
import './Search.scss';
import { Environment } from "../app/App";
import EnvironmentToggle from "../environment/EnvironmentToggle";
import LogoutButton from "../logout/Logout";

export type SearchProps = {
  entity: IEntity | null,
  environment: Environment,
  setEntity: React.Dispatch<React.SetStateAction<IEntity | null>>,
  toggleEnvironment: Function,
  logout: Function
}

export type DisplayState = 'empty' | 'results' | 'selected';

function inferDisplayState (data: IEntity[] | undefined, selected: IEntity | null): DisplayState {
  if (!!selected) { return 'selected'; }
  if (Array.isArray(data)) { return 'results'; }
  return 'empty';
}

const Search: FC<SearchProps> = (props) => {
  const [query, setQuery] = useState('');
  const [{data, loading, error}, runSearch] = useAxios<IEntity[]>({
    method: 'GET',
    baseURL: 'http://localhost:3004/',
  }, { manual: true });

  const displayState: DisplayState = inferDisplayState(data, props.entity);

  const search = () => {
    runSearch({ url: `${query}`, params: { environment: props.environment }});
    props.setEntity(null);
  };

  useEffect(() => {
    if (query !== '') {
      search();
    }
  }, [props.environment]);

  let display: JSX.Element | null = null;

  if (loading) {
    display = <p className="body-subtext" role="status">Loading...</p>;
  } else if (error) {
    display = <p className="body-subtext" role="status">Error : {error.message}</p>;
  } else if (Array.isArray(data)) {
    const result_s = data.length === 1 ? 'result' : 'results';
    display = <>
      <p className="body-subtext" role="status">Your search returned {data.length} {result_s}.</p>
      <EntitySet entities={data} setEntity={props.setEntity} />
    </>;
  }

  return (
    <section className={`search flex-start --${displayState}`}>
      <div className="bar">
        {/* uncomment the following once search is being implemented */}
        {/*<TextButton buttonText="Search" handleClick={() => { search(); }}></TextButton>*/}
        {/*<span>for</span>*/}
        {/*<input*/}
        {/*  value={query}*/}
        {/*  onChange={(e) => { setQuery(e.target.value)}}*/}
        {/*  onFocus={() => props.setEntity(null)}*/}
        {/*  onKeyPress={(evt) => { if (evt.key === 'Enter') { search(); }}}/>*/}
        <EnvironmentToggle environment={props.environment} toggleEnvironment={props.toggleEnvironment}/>
        <LogoutButton logout={props.logout}/>
      </div>

      {display}
    </section>
  );
}

export default Search;
